<template>
  <div class="careers">
    <div class="main-content">
      <div class="career-content">
        <div class="img-holder">
          <img src="../assets/img/careers.png" />
        </div>
        <div class="career">
          <div class="brand-left">
            <img class="icon" src="../assets/img/weChatIcon.svg"/>
            <img class="icon" src="../assets/img/instagramIcon.svg"/>
            <img class="icon" src="../assets/img/facebookIcon.svg"/>
          </div>
          <div class="brand-right">
            <h2>JOIN US TODAY</h2>
            <p class="bio">Asian Family Market offers a unique and rewarding workplace for passionate people with diverse backgrounds, experiences, and knowledge. We are an equal opportunity employer and encourage all qualified individuals to apply.

            Our mission is to enrich our customers’ lifestyles by bringing Asian American families the foods they love, while also introducing other American families to the diverse food options from Asia with our exceptionally convenient service and value.

            We recognize America’s diversity is the cornerstone of its pride and strength. AFM has made it a priority to reflect this growing diversity in the products we sell, the people we hire, and the culture we create in our organization. Accommodation is available in the recruitment and assessment stages of the hiring process for applicants with disabilities.

            Join us and help our culturally enriched company grow stronger!
            </p>
          </div>
        </div>
      </div>
        <div class="brand-footer">
          <p class="green">(425）643-8558</p>
          <p class="green">work</p>
          <div class="col">
            <p class="green">Asian Family Market</p>
            <p class="green">(known as AFM)</p>
          </div>
        </div>
      <div class="careers-foot">
        <p class="careers-head">LOCATION</p>
        <div class="location">
          <p class="careers-cont">1. Bellevue AFM 14515 NE 20th St, Bellevue WA 98007</p>
          <p class="careers-cont">2. Seattle AFM 13200 Aurora Ave N, Seattle WA 98133</p>
          <p class="careers-cont">3. Oregon AFC 3849 SW 117th Ave, Beaverton WA 97005</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "careers",
  data(){}
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/careers.less";
</style>



// WEBPACK FOOTER //
// src/view/careers.vue